/* <sst-product-card>: color swatches + quick add. Markup in snippets/sst-product-card.liquid. */
if (!customElements.get('sst-product-card')) {
  customElements.define(
    'sst-product-card',
    class SstProductCard extends HTMLElement {
      static ADDED_MS = 1800;

      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
        this.color = this.querySelector('[data-color][aria-pressed="true"]')?.dataset.color;
        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('mouseleave', () => this.toggle(false));
      }

      onClick(e) {
        const btn = e.target.closest('button');
        if (!btn) return;
        if (btn.matches('[data-quick-toggle]')) return this.toggle(!this.classList.contains('is-open'));
        if (btn.dataset.color) return this.pickColor(btn);
        if (btn.dataset.size || btn.matches('[data-add]')) this.add(btn);
      }

      toggle(open) {
        this.classList.toggle('is-open', open);
        this.querySelector('[data-quick-toggle]')?.setAttribute('aria-expanded', open);
      }

      pickColor(btn) {
        this.querySelectorAll('[data-color]').forEach((b) => b.setAttribute('aria-pressed', b === btn));
        this.color = btn.dataset.color;
        const variant = this.findVariant();
        this.swap('.sst-card__img--main', variant?.image);
        this.swap('.sst-card__img--hover', variant?.hover);
      }

      swap(selector, src) {
        const img = this.querySelector(selector);
        if (!src || !img) return;
        img.removeAttribute('srcset');
        img.src = src;
      }

      findVariant(size) {
        return this.variants.find(
          (v) => v.available && (!this.color || v.options.includes(this.color)) && (!size || v.options.includes(size))
        );
      }

      async add(btn) {
        const size = btn.dataset.size;
        const variant = this.findVariant(size);
        if (!variant) return this.flash(window.variantStrings?.soldOut || 'Sold out');
        btn.disabled = true;
        try {
          await SST.addToCart(variant.id);
          this.closest('dialog')?.close(); /* search popup: let the cart drawer show */
          if (document.querySelector('cart-drawer')) return this.toggle(false);
          this.flash(`${this.dataset.addedLabel || 'Added to bag'} · ${size || 1}`);
        } catch (err) {
          this.flash(err.message);
        } finally {
          btn.disabled = false;
        }
      }

      flash(text) {
        const choices = this.querySelector('[data-choices]');
        const added = this.querySelector('[data-added]');
        added.querySelector('[data-added-label]').textContent = text;
        choices.hidden = true;
        added.hidden = false;
        this.classList.add('is-open');
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          choices.hidden = false;
          added.hidden = true;
          this.toggle(false);
        }, SstProductCard.ADDED_MS);
      }
    }
  );
}
